import React from 'react'
import ArticleItemList from '../sections/ArticleItemList'
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Header from '../sections/Header';
import Footer from '../sections/Footer';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));


export default function Articles() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Header />
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12}>
            <ArticleItemList />
        </Grid>
        <Grid item xs={12}>
          <Paper className={classes.paper}><Footer/ ></Paper>
        </Grid>
      </Grid>
    </div>
  );

}
